<div *ngIf="page == 'lista'" class="customPanel">
  <span (click)="openInfo()" style="position: absolute; cursor: pointer" class="material-icons-outlined textXM">
    help
  </span>
  <h1 class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    {{this.localiser.get("fade.profiles.title")}}
  </h1>

  <div mat-dialog-content style="height: 80%" class="bodyForm" *ngIf="fades.length > 0">
    <table style="width: 40%; margin: auto">
      <tr *ngFor="let fade of fades" style="text-align: center">
        <td><h3 class="textS+">{{fade.nombre}}</h3></td>
        <td>
          <span id="editFadeIcon" (click)="editFadePage(fade)" style="color: #F2A356; cursor: pointer" class="material-icons-outlined textXM">
            edit
          </span>
        </td>
        <td>
          <span id="deleteFadeIcon" (click)="deleteFadePage(fade)" style="color: #FF0C41; cursor: pointer" class="material-icons-outlined textXM">
            delete
          </span>
        </td>
      </tr>
    </table>
  </div>

  <div mat-dialog-content style="height: 80%" class="bodyForm" *ngIf="fades.length <= 0">
    <div class="middleText" style="margin-top: 5%">
      <h3 class="textM centerVert">{{this.localiser.get("fade.profiles.noProfiles")}}</h3>
    </div>
  </div>

  <div mat-dialog-actions style="height: 7%">
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("fade.buttonExit")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button id="buttonCreateFade" class="customButtonColor textS" mat-button (click)="changePageToNew()">{{this.localiser.get("fade.profiles.buttonCreate")}}</button>
    </div>
  </div>


</div>

<div *ngIf="page == 'new' || page == 'edit'" class="customPanel">
  <h1 *ngIf="page == 'new'" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    {{this.localiser.get("fade.profiles.buttonCreate")}}
  </h1>
  <h1 *ngIf="page == 'edit'" class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    {{this.localiser.get("fade.profiles.edit")}}
  </h1>

  <div mat-dialog-content style="height: 80%" class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.name")}}</h5>
        <input [(ngModel)]="nombre" type="text" class="inputWidth textS+" maxlength="40">
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.description")}}</h5>
        <input [(ngModel)]="descripcion" type="text" class="inputWidth textS+" maxlength="50">
      </div>
    </div>

    <div class="row rowForm">
      <div class="col-9" style="text-align: right">
        <img class="profileImage" src="../../../assets/img/configuration_profile.png" alt="Configuration Profile">
      </div>
      <div class="col-3" style="display: grid">
        <div class="row" style="margin: auto">
          <div style="width: 20%; margin: auto">
            <span class="numberCircle textM"><span>6</span></span>
          </div>
          <div class="colRight">
            <h5 class="textS+">{{this.localiser.get("fade.profiles.maxWork")}}</h5>
            <input (input)="maxLengthCheckMaxWork($event)" [(ngModel)]="work_max" min="0" max="100" type="number"
                   style="width: 60%" class="textS+" oninput="validity.valid||(value='');">
          </div>
        </div>
        <div class="row" style="margin: auto">
          <div style="width: 20%; margin: auto;">
            <span id="minimunPercentIcon" class="numberCircle textM"><span>5</span></span>
          </div>
          <div class="colRight">
            <h5 class="textS+">{{this.localiser.get("fade.profiles.minWork")}}</h5>
            <input (input)="maxLengthCheckMinWork($event)" [(ngModel)]="work_min" min="0" max="100" type="number"
                   style="width: 60%" class="textS+" oninput="validity.valid||(value='');">
          </div>
        </div>
      </div>
    </div>

    <div class="row rowForm" style="width: 80%; margin-left: 1%">

      <div class="col" style="display: flex">

        <div style="width: 20%; margin: auto">
          <span class="numberCircle textM"><span>1</span></span>
        </div>
        <div class="colRight">
          <h5 class="textS+">{{this.localiser.get("fade.profiles.fadeIn")}}</h5>
          <span class="textS+" style="position: absolute; right: 20%">{{this.localiser.get("fade.profiles.seconds")}}</span>
          <mat-select id="selector-fade-in-time" class="fadeTimeSelect textS+" [(ngModel)]="selectedFadeInTimeKey" >
            <mat-option class="textS+" *ngFor="let optionFadeTime of optionsFadeTime" [value]="optionFadeTime.key" >
              {{ optionFadeTime.value }}
            </mat-option>
          </mat-select>
          <!--<mat-select id="selector-fade-in-time" class="fadeTimeSelect textS+" [(ngModel)]="fade_in" (ngModelChange)="onSelectionFadeInTimeChange($event)">
            <mat-option class="textS+" *ngFor="let optionFadeTime of optionsFadeTime" [value]="optionFadeTime.key" >
              {{ optionFadeTime.value }}
            </mat-option>
          </mat-select>-->
          <!--<input (input)="maxLengthCheckFadeIn($event)" [(ngModel)]="fade_in" type="number" max="999"
                 style="width: 50%" class="textS+">-->
        </div>

      </div>

      <div class="col" style="display: flex">

        <div style="width: 20%; margin: auto">
          <span class="numberCircle textM"><span>2</span></span>
        </div>
        <div class="colRight">
          <h5 class="textS+">{{this.localiser.get("fade.profiles.maxT")}}</h5>
          <span class="textS+" style="position: absolute; right: 20%">{{this.localiser.get("fade.profiles.minutes")}}</span>
          <input (input)="maxLengthCheckMaxT($event)" [(ngModel)]="max_t" type="number" min="0" max="999"
                 style="width: 50%" class="textS+" onkeypress="return event.charCode != 45" >
        </div>

      </div>

      <div class="col" style="display: flex">
        <div style="width: 20%; margin: auto">
          <span class="numberCircle textM"><span>3</span></span>
        </div>
        <div class="colRight">
          <h5 class="textS+">{{this.localiser.get("fade.profiles.fadeOut")}}</h5>
          <span class="textS+" style="position: absolute; right: 20%">{{this.localiser.get("fade.profiles.seconds")}}</span>
          <mat-select id="selector-fade-out-time" class="textS+ fadeTimeSelect" [(ngModel)]="selectedFadeOutTimeKey">
            <mat-option class="textS+" *ngFor="let optionFadeTime of optionsFadeTime" [value]="optionFadeTime.key" >
              {{ optionFadeTime.value }}
            </mat-option>
          </mat-select>
          <!--<mat-select id="selector-fade-out-time" class="textS+ fadeTimeSelect" [(ngModel)]="fade_out" (ngModelChange)="onSelectionFadeOutTimeChange($event)">
            <mat-option class="textS+" *ngFor="let optionFadeTime of optionsFadeTime" [value]="optionFadeTime.key" >
              {{ optionFadeTime.value }}
            </mat-option>
          </mat-select>-->
          <!--<input (input)="maxLengthCheckFadeOut($event)" [(ngModel)]="fade_out" type="number" max="999"
                 style="width: 50%" class="textS+">-->
        </div>
      </div>

      <div class="col" style="display: flex">
        <div style="width: 20%; margin: auto">
          <span class="numberCircle textM"><span>4</span></span>
        </div>
        <div class="colRight">
          <h5 class="textS+">{{this.localiser.get("fade.profiles.minT")}}</h5>
          <span class="textS+" style="position: absolute; right: 20%">{{this.localiser.get("fade.profiles.minutes")}}</span>
          <input id="bar" (input)="maxLengthCheckMinT($event)" [(ngModel)]="min_t" type="number" min="0" max="999"
            style="width: 50%" class="textS+" onkeypress="return event.charCode != 45" >
          <!--          <input id="bar" (input)="maxLengthCheckMinT($event)" [(ngModel)]="min_t" type="number" min="0" max="999"
            style="width: 50%" class="textS+" >-->
        </div>

      </div>

    </div>
    <div class="row rowForm" style="width: 80%; margin-left: 1%">
      <div class="col" style="display: flex; justify-content: center;">
        <div>
          <h3 *ngFor="let error of this.errorsArray" class="textS" style="color: #FF0C41"><b>{{error}}</b></h3>
        </div>
      </div>
    </div>

  </div>

  <div mat-dialog-actions style="height: 7%">
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="changePageToLista()">{{this.localiser.get("fade.buttonBack")}}</button>
    </div>
    <div  *ngIf="page == 'new'" class="col" style="text-align: center">
      <button id="buttonSaveFade" class="customButtonColor textS" mat-button (click)="newFade()">{{this.localiser.get("fade.buttonSave")}}</button>
    </div>
    <div  *ngIf="page == 'edit'" class="col" style="text-align: center">
      <button id="button-update" class="customButtonColor textS" mat-button (click)="updateFade()">{{this.localiser.get("fade.buttonUpdate")}}</button>
    </div>
  </div>
</div>

<div *ngIf="page == 'delete'" class="customPanel">
  <h1 class="textM" style="text-align: center; height: 7%; margin: auto" mat-dialog-title>
    {{this.localiser.get("fade.profiles.deleteTitle")}}
  </h1>

  <div mat-dialog-content style="height: 80%;" class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.name")}}</h5>
        <h3 class="textS+">{{nombre}}</h3>
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.description")}}</h5>
        <h3 class="textS+">{{descripcion}}</h3>
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteMaxWork")}}</h5>
        <h3 class="textS+">{{work_max}}</h3>
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteMinWork")}}</h5>
        <h3 class="textS+">{{work_min}}</h3>
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteFadeIn")}}</h5>
        <h3 class="textS+">{{fade_in}}</h3>
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteFadeOut")}}</h5>
        <h3 class="textS+">{{fade_out}}</h3>
      </div>
    </div>

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteMaxT")}}</h5>
        <h3 class="textS+">{{max_t}}</h3>
      </div>
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("fade.profiles.deleteMinT")}}</h5>
        <h3 class="textS+">{{min_t}}</h3>
      </div>
    </div>

  </div>

  <div mat-dialog-actions style="height: 7%;">
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="changePageToLista()">{{this.localiser.get("fade.buttonBack")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button id="buttonDeleteFade" class="customButtonColorDelete textS" mat-button (click)="deleteFade()">{{this.localiser.get("fade.delete")}}</button>
    </div>
  </div>
</div>
